import type { OverviewSession } from "./api.js";
import type { SessionRecord } from "./device.js";

// Hotový a rozpracovaný test osoby (REQ-041): ze zařízení a na přihlášeném zařízení i ze sezení
// identity (REQ-033), aby se člověk vrátil k výsledku a nezačínal omylem znovu.

export interface TestStanding {
  /** Poslední hotový výsledek: adresa Skicy a datum dokončení (u starších záznamů zařízení není). */
  readonly done: { readonly href: string; readonly finishedAt: string | null } | null;
  /** Rozpracované sezení novější než hotový výsledek; `onDevice: false` je sezení identity z jiného zařízení. */
  readonly open: { readonly sessionId: string; readonly onDevice: boolean } | null;
}

const time = (iso: string | null | undefined) => (iso == null ? 0 : Date.parse(iso));

export function standingOf(slug: string, lang: string, local: readonly SessionRecord[], remote: readonly OverviewSession[]): TestStanding {
  const mine = local.filter((s) => s.slug === slug && s.origin === "user");
  const theirs = remote.filter((s) => s.slug === slug);
  const deviceDone = mine
    .filter((s) => s.done === true && typeof s.resultToken === "string" && s.resultToken !== "")
    .map((s) => ({ id: s.id, href: `/${lang}/r/${s.resultToken!}`, finishedAt: s.finishedAt ?? null, at: time(s.finishedAt ?? s.createdAt) }));
  const identityDone = theirs
    .filter((s) => s.status === "done" && s.result_id !== null && !deviceDone.some((d) => d.id === s.id))
    .map((s) => ({ id: s.id, href: `/${lang}/me/results/${s.result_id!}`, finishedAt: s.finished_at, at: time(s.finished_at ?? s.started_at) }));
  const done = [...deviceDone, ...identityDone].sort((a, b) => b.at - a.at)[0] ?? null;
  const open = [
    ...mine.filter((s) => s.done !== true && s.token !== "").map((s) => ({ sessionId: s.id, onDevice: true, at: time(s.createdAt) })),
    ...theirs.filter((s) => s.status === "in_progress" && !mine.some((m) => m.id === s.id)).map((s) => ({ sessionId: s.id, onDevice: false, at: time(s.started_at) })),
  ].sort((a, b) => b.at - a.at)[0];
  return {
    done: done === null ? null : { href: done.href, finishedAt: done.finishedAt },
    open: open === undefined || (done !== null && open.at < done.at) ? null : { sessionId: open.sessionId, onDevice: open.onDevice },
  };
}
